import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { homeRouting } from './home.routing';
import { TranslateModule } from '@ngx-translate/core';
import { HomeComponent } from './Home.component';
import { HomeHeaderComponent } from './home-header.component';
import { MaintenanceComponent } from '../Maintenance/Maintenance.component';
import { ConfigurationModule } from '../Configuration/configuration.module';


@NgModule({
    imports: [
        CommonModule,
        homeRouting,
        TranslateModule.forRoot(),
        ConfigurationModule,
    ],
    declarations: [
        HomeComponent,
        HomeHeaderComponent,
        MaintenanceComponent,
    ],
    providers: []
})
export class HomeModule { }
